module.exports = __webpack_public_path__ + "img/sub-banner1.21a3d669.jpg";